import React from 'react';
import PropTypes from 'prop-types';
import { ExportToCsv } from 'export-to-csv';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import SonicGridToolBar from './SonicGridToolBar'
import SonicCell from './SonicCell'

function getSorting(order, orderBy) {
  console.log('getSorting')
  console.log(order)
  console.log(orderBy)
  if (order === 'desc'){
    return (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
  }else{
    return (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1)
  }
  return 0
}

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: '#C5C6C7'
  },
  button: {
    marginTop: theme.spacing.unit * 5,
    marginBottom: theme.spacing.unit
  },
  totals:{
    marginBottom: theme.spacing.unit
  }
});
//save view options
//add custom filter 


class SonicGrid extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        order: 'desc',
        orderBy: 'soldEpoch',
        selected: [],
        page: 0,
        rowsPerPage: 5,
        showDateSearch: false,
        cellSize: 12,
        spacing: 16,
        view: 'cells',
      };
    }
    changeColumns = () => {
      const { cellSize } = this.state
      if(cellSize === 12){
        this.setState({cellSize: 6})
      }else{
        this.setState({cellSize: 12})
      }

    }
    changeView = (view) => {
      this.setState({view})
    }
    exportCSV = () => {
      const { isFiltering, filterString } = this.state;
      const { rowData } = this.props;
      if(rowData.length < 1){
        return 
      }
      let data = rowData.slice(0)
      console.log(isFiltering)
      if (isFiltering){
          data = data.filter(item => {
              const rawString = JSON.stringify(item)
              return rawString.includes(filterString)
            })
      }

      const exportData = data.map((item) => {
          const { keywordRating, vertical, destinationEmailID, soldEpoch, actions, individual, ...theRest } = item
          return {...theRest, individual: individual === 'individual' ? true : false}
      })


      const options = { 
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        filename:'My Sonic Leads',
        //showLabels: true, 
        //showTitle: true,
        title: 'My Sonic Leads',
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      };
     
      const csvExporter = new ExportToCsv(options);
     
      csvExporter.generateCsv(exportData);
    }
    handleRequestSort = (event, property) => {
      const orderBy = property;
      let order = 'desc';
  
      if (this.state.orderBy === property && this.state.order === 'desc') {
        order = 'asc';
      }
  
      this.setState({ order, orderBy });
    };
  
    handleSelectAllClick = (event, checked) => {
      const { rowData } = this.props
      if (checked) {
        this.setState({ selected: rowData.map(n => n.id) });
        return;
      }
      this.setState({ selected: [] });
    };
  
    handleClick = (event, id) => {
  
      console.log(event)
      console.log(event.target)
  
      const { selected } = this.state;
      const { checkbox, rowsSelected } = this.props
      const selectedIndex = selected.indexOf(id);
  
      let newSelected = [];
  
      if (checkbox){
  
          if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
          } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
          } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
          } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
              selected.slice(0, selectedIndex),
              selected.slice(selectedIndex + 1),
            );
          }
      }else{
        newSelected.push(id)
        rowsSelected([id])
      }
  
      this.setState({ selected: newSelected });
    };
  
    handleChangePage = (event, page) => {
      this.setState({ page });
    };
  
    handleChangeRowsPerPage = event => {
      this.setState({ rowsPerPage: event.target.value });
    };
    searchStringChanged = (event) => {
      //need to add partial match with option on toolbar
      //need to add check to see if new query is needed and to push back to parent and skip internal filter. Let get set via a prop
      const value = event.target.value
      let isFiltering = true
     // clearTimeout(saveTimeout);
      if (value === '' || value === undefined || value === null){
        isFiltering = false
      }
      this.setState({isFiltering, filterString: value})
      /*saveTimeout = setTimeout(() => {
        this.setState({isFiltering, event})
      }, 1000);*/
    }
    
    makeRows = () => {
  
      const { classes, rowData, checkbox, updateItem } = this.props;
      const { order, orderBy, selected, rowsPerPage, page, isFiltering, filterString, cellSize, view } = this.state;
  
      let data = rowData.slice(0)
      console.log(isFiltering)
      if (isFiltering){
          data = data.filter(item => {
              const rawString = JSON.stringify(item)
              return rawString.includes(filterString)
            })
      }
  
   
  
  
      const rows = data
        .sort(getSorting(order, orderBy, 'soldEpoch'))
        //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map(n => {
         // const isSelected = this.isSelected(n.id);
              const { id } = n
              return (
                <Grid key={id} item xs={cellSize}>
         
                {/*this.makeTableCells(n)*/}
                <SonicCell id={id} cellSize={cellSize} updateItem={updateItem} view={view} item={n}/>
           
              </Grid>
              )
              })
     
     
        

        return rows
    }
    makeCell = (item) => {
    /*  let itemCount = 0;
      const tableCells = Object.keys(item).map(key => {
          itemCount =  itemCount + 1
          return <TableCell key={itemCount} component="th" scope="row" padding="none">{item[key]}</TableCell>
        })
      return tableCells*/
    };
    toggleDateSearch = () => {
      this.setState({showDateSearch: !this.state.showDateSearch})
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;
  
    render() {
      const { classes, loading, rowData, totalItems, columnData, title, checkbox, defaultDateRange, searchDatesUpdated, selectedCampaign, campaignSelected, filterSelected, searchDate, searchMore, scrollID, lastResultSelected } = this.props;
      const { order, orderBy, selected, rowsPerPage, page, showDateSearch, spacing } = this.state;
      const currentItems = rowData.length

      const emptyRows = rowsPerPage - Math.min(rowsPerPage, rowData.length - page * rowsPerPage);
  
      return (
        <Paper className={classes.root}>
          <SonicGridToolBar 
          exportCSV={this.exportCSV}
          numSelected={selected.length} 
          title={title} 
          search={this.searchStringChanged} 
          checkbox={checkbox} 
          showDateSearch={showDateSearch} 
          toggleDateSearch={this.toggleDateSearch} 
          defaultDateRange={defaultDateRange}
          selectedCampaign={selectedCampaign}
          lastResultSelected={lastResultSelected}
          searchDatesUpdated={searchDatesUpdated}
          campaignSelected={campaignSelected}
          filterSelected={filterSelected}
          searchDate={searchDate}
          changeView={this.changeView}
          changeColumns={this.changeColumns}
          currentItems={currentItems}
          totalItems={totalItems}

          />
        <Grid container spacing={spacing}>

         {this.makeRows()}

        </Grid>
       {scrollID ? <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
      >

      {loading ? 'Loading...' : <Button className={classes.button} color="primary" onClick={searchMore}> More </Button>}
      
      <Typography className={classes.totals}> {`Showing ${currentItems} of ${totalItems}`}</Typography>
       </Grid> : null}
       
        </Paper>
      );
    }
  }
  
  SonicGrid.propTypes = {
    classes: PropTypes.object.isRequired,
    rowData: PropTypes.array.isRequired
  };
  
  export default withStyles(styles)(SonicGrid);


// WEBPACK FOOTER //
// ./src/components/lib/SonicGrid.js